import { useMemo } from 'react'

import { parseVariableTextSingleCell } from '@/core/app-builder/parser/variable-text'
import { isDescendant, parseStringToDescendant } from '@/lib/slate'
import { useAppAuthContext } from '@/context/__project__/AppAuthContext'
import { useDbClientContext } from '@/context/__project__/DbClientContext'

/**
 * Custom hook to read variable text consisting of (string) input and single-cell value.
 */
export const useVariableTextSingleCell = (value = '') => {
  const { dbClient, language, userSpecific } = useDbClientContext()
  const { userEmail } = useAppAuthContext()

  return useMemo(() => {
    if (isDescendant(value) && !!dbClient) {
      const node = parseStringToDescendant(value)
      return parseVariableTextSingleCell(node, dbClient, language, userSpecific, userEmail)
    }
    return value
  }, [dbClient, language, userEmail, userSpecific, value])
}
